import { render, staticRenderFns } from "./myProcess.vue?vue&type=template&id=64992cb0&scoped=true"
import script from "./myProcess.vue?vue&type=script&lang=js"
export * from "./myProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64992cb0",
  null
  
)

export default component.exports